<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
        		<template slot="BodyFormLoad">
					<div class="container-fluid">
						<form id="FormElementopaquete" role="form" method="post" autocomplete="off" onSubmit="return false">

							<div class="row">
								<div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
									<div class="avatar-upload">
										<div class="avatar-edit">
											<input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview'))" id="file" name="file" ref="fileImg" accept=".png, .jpg, .jpeg">
											<label for="file"></label>
										</div>
										<div class="avatar-preview">
											<div id="imagePreview" :style="'background-image: url('+RutaFile+objElementopaquete.Imagen+')'" :src="RutaFile+objElementopaquete.Imagen">
											</div>
										</div>
									</div>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
									<div class="form-group row">
										<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
											<label class="form-label" for="Nombre">Nombre</label>
											<input type="text" v-model="objElementopaquete.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
											<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
										</div>
									</div>

									<div class="form-group row">
										<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
											<label class="form-label" for="Cantidad">Cantidad</label>
											<input type="text" v-model="objElementopaquete.Cantidad" @input="$onlyNums($event,objElementopaquete,'Cantidad');CalcularTotal();" class="form-control" id="Cantidad" placeholder="Ingresar Cantidad" />
											<CValidation v-if="this.errorvalidacion.Cantidad" :Mensaje="'*'+errorvalidacion.Cantidad[0]"/>
										</div>

										<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
											<label class="form-label" for="Precio">Precio</label>
											<input type="text" v-model="objElementopaquete.Precio" @input="$number_decimal($event,objElementopaquete,'Precio');CalcularTotal();" class="form-control" id="Precio" placeholder="Ingresar Precio" />
											<CValidation v-if="this.errorvalidacion.Precio" :Mensaje="'*'+errorvalidacion.Precio[0]"/>
										</div>										

										<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
											<label class="form-label" for="Precio Total">Precio Total</label>
											<input type="text" v-model="objElementopaquete.PrecioTotal" class="form-control" id="PrecioTotal" disabled />
											<CValidation v-if="this.errorvalidacion.PrecioTotal" :Mensaje="'*'+errorvalidacion.PrecioTotal[0]"/>
										</div>
									</div>
								</div>
							</div>

								
							<div class="form-group row mt-2">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label class="form-label" for="Descripcion">Descripción en español</label>
									<textarea v-model="objElementopaquete.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripción en español" rows="3"></textarea>
									<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
								</div>
							</div>
								
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label class="form-label" for="DescripcionIng">Descripcion en Inglés</label>
									<textarea v-model="objElementopaquete.DescripcionIng" class="form-control" id="DescripcionIng" placeholder="Ingresar Descripcion en Inglés" rows="3"></textarea>
									<CValidation v-if="this.errorvalidacion.DescripcionIng" :Mensaje="'*'+errorvalidacion.DescripcionIng[0]"/>
								</div>
							</div>
													
							<br>
							<CBtnSave :poBtnSave="oBtnSave" />

						</form>
                    </div>
				</template>
    		</CLoader>
		</template>
	</CList>
   
</template>
<script>

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionElementopaquete';

export default {
    name: 'FormElementopaquete',
    props: ['Id'],
    components:{
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario de Elementos del Paquete',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'elementopaquete',
                EmitSeccion: EmitEjecuta,
            },
            objElementopaquete: {
				IdElementoPaq: 0,
				IdPaquete: 0,
				Nombre: '',
				Precio: '',
				Cantidad: '',
				PrecioTotal: 0,
				Descripcion: '',
				DescripcionIng: '',
				Imagen: '',
				UrlImagen: '',
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
			ValidElement: Configs.validImage3m,
            RutaFile: '',
            Img: null,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
			let Imagen = this.$refs.fileImg.files[0];

            if(Imagen === undefined && this.objElementopaquete.IdElementoPaq == 0){
                this.$toast.warning('Debe agregar una imagen');
                return false;
            }

			formData.set('IdElementoPaq', this.objElementopaquete.IdElementoPaq);
			formData.set('IdPaquete', this.objElementopaquete.IdPaquete);
			formData.set('Nombre', this.objElementopaquete.Nombre);
			formData.set('Precio', this.objElementopaquete.Precio);
			formData.set('PrecioTotal', this.objElementopaquete.PrecioTotal);
			formData.set('Cantidad', this.objElementopaquete.Cantidad);
			formData.set('Descripcion', this.objElementopaquete.Descripcion);
			formData.set('DescripcionIng', this.objElementopaquete.DescripcionIng);
			formData.set('TipoImagen','PaquetesElem');

			formData.set('ImagenAntigua', this.objElementopaquete.Imagen);
			formData.append('Imagen',Imagen);


			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;

			await this.$http.post('elementospaquete', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
			this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "elementospaquete/"+this.objElementopaquete.IdElementoPaq
            ).then((res) => {
                this.objElementopaquete = res.data.data;
				this.RutaFile = res.data.RutaFile;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objElementopaquete = {
				IdElementoPaq: 0,
				IdPaquete: 0,
				Nombre: '',
				Precio: '',
				Cantidad: '',
				PrecioTotal: 0,
				Descripcion: '',
				DescripcionIng: '',
				Imagen: '',
				UrlImagen: '',
            }
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
		// PROPIOS
		CalcularTotal(){
			let Total;
			Total = parseFloat(this.objElementopaquete.Precio)*parseFloat(this.objElementopaquete.Cantidad);
			if (isNaN(Total)) {
				this.objElementopaquete.PrecioTotal = 0;
			}
			else{
				this.objElementopaquete.PrecioTotal = Total;
			}
		},
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

		let ObjPaquete = JSON.parse(sessionStorage.getItem('objPaquete'));
		this.objElementopaquete.IdPaquete = ObjPaquete.IdPaquete;

        if(this.Id!='') 
        {
            this.objElementopaquete.IdElementoPaq = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>